import { TFunction } from "i18next";
import { ICourse } from "redux/reducers/models/facility";
import { convertHoles } from "helpers/Helpers";

const blockedTypeOptions = (t: TFunction<"translation", undefined>) => [
  { label: t("secure.facility.tee_sheet.tee_sheet_edit.066"), value: "none" },
  { label: t("secure.facility.tee_sheet.tee_sheet_edit.001"), value: "open" },
  { label: t("secure.facility.tee_sheet.tee_sheet_edit.002"), value: "blocked" },
  { label: t("secure.facility.tee_sheet.tee_sheet_edit.067"), value: "crossover" },
];

const divisionOptions = (t: TFunction<"translation", undefined>, course: ICourse) => [
  { label: `${convertHoles(9, course)} ${t("Holes")}`, value: 1 },
  { label: `${convertHoles(18, course)} ${t("Holes")}`, value: 2 },
];

const cartRuleOptions = (t: TFunction<"translation", undefined>) => [
  { label: t("secure.facility.tee_sheet.tee_sheet_edit.068"), value: "empty" },
  { label: t("secure.facility.tee_sheet.tee_sheet_edit.006"), value: "none" },
  { label: t("secure.facility.tee_sheet.tee_sheet_edit.007"), value: "optional" },
  { label: t("secure.facility.tee_sheet.tee_sheet_edit.008"), value: "required" },
];

export { blockedTypeOptions, divisionOptions, cartRuleOptions };
